import { uiRows } from './types-def.js';
/**
 * `web/sheets/cards` (2.M; CS r6c deliverable 205), due at exit-2c: the spell and item card form of
 * a canon page, and the copy of an SRD card.
 */
export const SHEETS_CARDS_INTERACTIONS = uiRows([
    {
        id: 'cards.form.new',
        module: 'web/sheets/cards',
        behavior: 'New spell and New item open an empty card form on a new page of that type',
        owner: '2.M',
        since: 'exit-2c',
    },
    {
        id: 'cards.form.edit',
        module: 'web/sheets/cards',
        behavior: "The card form edits the page's card and Save writes it, its preview kept in step",
        owner: '2.M',
        since: 'exit-2c',
    },
    {
        id: 'cards.form.customize',
        module: 'web/sheets/cards',
        behavior: "Customize copies an SRD spell or item into a canon page with the card's values",
        owner: '2.M',
        since: 'exit-2c',
    },
    {
        id: 'cards.form.compare',
        module: 'web/sheets/cards',
        behavior: 'Compare shows the card beside the SRD source it was copied from',
        owner: '2.M',
        since: 'exit-2c',
    },
]);
//# sourceMappingURL=sheets-cards.js.map